import {
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UsersService } from 'src/app/services/users/users.service';
import { NgxCsvParser } from 'ngx-csv-parser';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { lastValueFrom } from 'rxjs';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Error } from 'src/app/models/error.model';
import { ImportUserReport } from 'src/app/models/import-user-report.model';
import {
  toCreateUserModel,
  UserCSVImport,
} from 'src/app/models/user-info.model';
import { Role } from 'src/app/models/role.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Sort } from '@angular/material/sort';

@Component({
  selector: 'app-user-import-form-dialog',
  templateUrl: './user-import-form.component.html',
  styleUrls: ['./user-import-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UserImportFormComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  isBusy = false;
  isFileUploaded = false;
  isCompleted = false;

  csvRecords: UserCSVImport[] = [];
  header = true;
  ngxCsvParser: NgxCsvParser;

  isUserCreated = false;

  username: string;
  error: Error;

  usernames: { User: string; Username: string }[];
  errorsimport: { User: string; Username: string }[];

  progressvalue = 0;
  userlength = 0;

  filename: string;
  fileUrl: SafeResourceUrl;
  createdUserIndex: number;

  report: ImportUserReport[];

  dataSource: MatTableDataSource<UserCSVImport>;
  displayedColumns: string[] = [];
  expandedElement: UserCSVImport | null;
  windowWidth: number = window.innerWidth;
  sortedValue: string;

  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };

  constructor(
    public matDialogRef: MatDialogRef<UserImportFormComponent>,
    private _userService: UsersService,
    private sanitizer: DomSanitizer
  ) {
    this.isBusy = false;

    this.userlength = 0;
    this.progressvalue = 0;
    this.ngxCsvParser = new NgxCsvParser();

    this.usernames = [];
    this.errorsimport = [];

    this.filename = '';

    this.report = [];
    this.createdUserIndex = 0;
  }

  ngOnInit(): void {
    this.updateDisplayedColumns();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.windowWidth = window.innerWidth;
    this.updateDisplayedColumns();
  }

  updateDisplayedColumns(): void {
    if (this.windowWidth >= 1300) {
      this.displayedColumns = [
        'officialFirstName',
        'officialLastName',
        'dateOfBirth',
        'gender',
        'firstName',
        'lastName',
        'email',
        'phone',
        'expand',
      ];
    } else if (this.windowWidth < 1300 && this.windowWidth >= 1150) {
      this.displayedColumns = [
        'officialFirstName',
        'officialLastName',
        'dateOfBirth',
        'gender',
        'firstName',
        'lastName',
        'email',
        'expand',
      ];
    } else if (this.windowWidth < 1150 && this.windowWidth >= 1000) {
      this.displayedColumns = [
        'officialFirstName',
        'officialLastName',
        'dateOfBirth',
        'gender',
        'firstName',
        'lastName',
        'expand',
      ];
    } else if (this.windowWidth < 1000 && this.windowWidth >= 900) {
      this.displayedColumns = [
        'officialFirstName',
        'officialLastName',
        'dateOfBirth',
        'gender',
        'firstName',
        'expand',
      ];
    } else if (this.windowWidth < 900 && this.windowWidth >= 750) {
      this.displayedColumns = [
        'officialFirstName',
        'officialLastName',
        'dateOfBirth',
        'gender',
        'expand',
      ];
    } else if (this.windowWidth < 750 && this.windowWidth >= 650) {
      this.displayedColumns = [
        'officialFirstName',
        'officialLastName',
        'dateOfBirth',
        'expand',
      ];
    } else if (this.windowWidth < 650) {
      this.displayedColumns = [
        'officialFirstName',
        'officialLastName',
        'expand',
      ];
    }
  }

  // Your applications input change listener for the CSV File
  fileChangeListener(event: Event): void {
    // Select the files from the event
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      const files = input.files;
      this.filename = input.files[0].name;
      // Parse the file you want to select for the operation along with the configuration
      this.ngxCsvParser
        .parse(files[0], { header: this.header, delimiter: ';' })
        .pipe()
        .subscribe((result: UserCSVImport[]) => {
          console.log(result);
          this.csvRecords = result;
          this.userlength = this.csvRecords.length;
          this.isFileUploaded = true;
          this.isCompleted = false;
          setTimeout(() => {
            this.dataSource = new MatTableDataSource(this.csvRecords);
            this.dataSource.paginator = this.paginator;
          });
        });
    }
  }

  async importUsers(): Promise<void> {
    this.createdUserIndex = 0;

    // Replace empty value by NULL
    this.csvRecords.forEach(function (user) {
      if (user.groupEtablissementList != '') {
        const groupEtablissementList = user.groupEtablissementList.split('/');
        user.groupEtablissement = [];

        groupEtablissementList.forEach(function (value) {
          user.groupEtablissement.push(value);
        });
      }

      if (user.organisationList != '') {
        const orgsList = user.organisationList.split('/');
        user.organisation = [];

        orgsList.forEach(function (value) {
          user.organisation.push(value);
        });
      }

      if (user.rolesList != '') {
        const roleList = user.rolesList.split('/');
        user.roles = [];

        roleList.forEach(function (value) {
          const tempRole = new Role();
          tempRole.name = value;
          user.roles.push(tempRole);
        });
      }

      Object.keys(user).forEach(function (key) {
        if (user[key] === '') {
          user[key] = null;
        }
      });
    });

    setTimeout(() => {
      this.dataSource.data = this.csvRecords;
    });

    for (let _i = 0; _i < this.csvRecords.length; _i++) {
      this.progressvalue = (_i / this.csvRecords.length) * 100;
      this.username = '';

      await this.createUser(this.csvRecords[_i]);
      this.createdUserIndex++;
    }

    if ((this.progressvalue = this.userlength)) {
      this.isBusy = false;
      this.isCompleted = true;
      this.progressvalue = 100;
    }

    let data = 'STATUS;USERNAME;MESSAGE' + '\n';

    this.report.forEach(function (rep) {
      if (rep.status === 'Success') {
        data =
          data + 'SUCESS' + ';' + rep.userImported + ';' + rep.message + '\n';
      } else {
        data =
          data + 'ERROR' + ';' + rep.userImported + ';' + rep.message + '\n';
      }
    });

    const blob = new Blob([data], { type: 'text/csv;encoding:utf-8' });
    this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      window.URL.createObjectURL(blob)
    );
  }

  async createUser(newUser: UserCSVImport): Promise<void> {
    this.isUserCreated = false;

    try {
      this.isBusy = true;
      await lastValueFrom(
        this._userService.createUser(toCreateUserModel(newUser))
      ).then(response => {
        this.isUserCreated = true;
        this.username = response.username;

        const report = new ImportUserReport();
        report.status = 'Success';
        report.userImported =
          newUser.officialFirstName + ' ' + newUser.officialLastName;
        report.message = 'Username : ' + this.username;
        this.report.push(report);
        this.usernames.push({
          Username: report.message,
          User: report.userImported,
        });

        this.isBusy = false;
      });
    } catch (error) {
      let customError: Error = { error: undefined };
      if (error.statusText == 'Unknown Error') {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error.errors) {
          customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
        } else if (error.error) {
          customError = error.error;
        }
      }

      if (customError.error === undefined) {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      }

      const report = new ImportUserReport();
      report.status = 'Error';
      report.userImported =
        newUser.officialFirstName + ' ' + newUser.officialLastName;
      report.message = 'Error : ' + customError.error.message;

      this.report.push(report);

      this.errorsimport.push({
        Username: report.message,
        User: report.userImported,
      });

      this.error = customError;
      this.isUserCreated = false;
    } finally {
      /* empty */
    }
  }

  sortData(sort: Sort) {
    this.sortedValue = sort.active;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

    if (!sort.active || sort.direction === '') {
      this.sortedValue = null;
      return;
    }

    this.dataSource.data = this.dataSource.data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'officialFirstName':
          return this.compare(
            a.officialFirstName.toLocaleLowerCase(),
            b.officialFirstName.toLocaleLowerCase(),
            isAsc
          );
        case 'officialLastName':
          return this.compare(
            a.officialLastName.toLocaleLowerCase(),
            b.officialLastName.toLocaleLowerCase(),
            isAsc
          );
        case 'gender':
          return this.compare(
            a.gender.toLocaleLowerCase(),
            b.gender.toLocaleLowerCase(),
            isAsc
          );
        case 'firstName':
          return this.compare(
            a.firstName.toLocaleLowerCase(),
            b.firstName.toLocaleLowerCase(),
            isAsc
          );
        case 'lastName':
          return this.compare(
            a.lastName.toLocaleLowerCase(),
            b.lastName.toLocaleLowerCase(),
            isAsc
          );
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  toggleRow(element: UserCSVImport): void {
    this.expandedElement = this.expandedElement === element ? null : element;
  }
}
